module.exports = __webpack_public_path__ + "img/伊顿.png";